import { z } from "zod";

import { SERVER_MODAL_ICON } from "@/features/server-modals/models";

export const serverModalSchema = z.object({
  id: z.number(),
  title: z.string(),
  icon: z.enum(SERVER_MODAL_ICON).nullable(),
  body: z.string(),
  footer: z.string().optional(),
  callToActionUrl: z.string().nullable(),
});
